exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".el-checkbox__input{width:20px}.el-checkbox__input.is-checked .el-checkbox__inner{background-color:#20a499;border:1px solid #20a499}.el-checkbox__input.is-focus .el-checkbox__inner{border:1px solid #20a499}.bgSetting-bottom,.bgSetting-bottom .el-button{position:relative}.bgSetting-bottom .el-button span{position:absolute;top:8px;left:0;width:100px}.bgSet{height:100%}.bgSet .bgSetting-bottom{height:807px;margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js??ref--2-2!./src/statics/css/bgSet.scss
// module id = 608
// module chunks = 1